import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage, useIntl} from "react-intl";

import {Box} from "@mui/material";

import StatCard from "components/dashboard/StatCard";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import MobileCarousel from "components/MobileCarousel";

import {black500, red500} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

function StockAlertKpis({ data, loading, currency }) {
    const intl = useIntl();

    const totalAlerts = data?.totalAlerts ?? 0;
    const lostRevenue = data?.lostRevenue ?? 0;

    let topCategory = data?.topCategory ?? "—";
    if (topCategory === 'other') {
        topCategory = <FormattedMessage id="dashboard.stockAlerts.chart.byCategory.otherCategory" />
    }

    const cardAlerts = (
        <StatCard
            label={<FormattedMessage id="dashboard.stockAlerts.kpi.totalAlerts" />}
            value={<span style={{ color: red500 }}>{totalAlerts.toLocaleString()}</span>}
            segmentAverage={<FormattedMessage id="dashboard.stockAlerts.kpi.totalAlerts.subtitle" />}
            loading={loading}
            tooltip={intl.formatMessage({ id: "dashboard.tooltip.totalAlerts" })}
        />
    );
    const cardCaManque = (
        <StatCard
            label={<FormattedMessage id="dashboard.stockAlerts.kpi.caManque" />}
            value={
                <span style={{ color: red500 }}>
                    <FormattedNumberWithCurrency
                        value={lostRevenue}
                        currency={currency}
                    />
                </span>
            }
            segmentAverage={<FormattedMessage id="dashboard.stockAlerts.kpi.caManque.subtitle" />}
            loading={loading}
            tooltip={intl.formatMessage({ id: "dashboard.tooltip.stockCaManque" })}
        />
    );
    const cardTopCategory = (
        <StatCard
            label={<FormattedMessage id="dashboard.stockAlerts.kpi.topCategory" />}
            value={
                <div style={{ fontSize: UserAgentUtils.isMobile() ? '24px' : "32px", fontWeight: 700, color: black500 }}>
                    {topCategory}
                </div>
            }
            segmentAverage={<FormattedMessage id="dashboard.stockAlerts.kpi.topCategory.subtitle" />}
            loading={loading}
            tooltip={intl.formatMessage({ id: "dashboard.tooltip.topCategory" })}
        />
    );

    return (
        <Box sx={{ mb: 3, mt: 2 }}>
            <MobileCarousel>
                {cardAlerts}
                {cardCaManque}
                {cardTopCategory}
            </MobileCarousel>

            <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: "row", gap: 2 }}>
                {cardAlerts}
                {cardCaManque}
                {cardTopCategory}
            </Box>
        </Box>
    );
}

StockAlertKpis.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
};

export default StockAlertKpis;
